import {
    DEFAULT_DOWNLOAD_TYPE,
    DEFAULT_DOWNLOAD_SIZE,
    DEFAULT_BACKGROUND_SHAPE,
    DEFAULT_COLOR
} from "icons/helpers";
import { sendPageView, sendEvent } from "js/utils/google-analytics";

export const getIconFilename = ({ icon, type, color }) => {
    const fileType = type.toLowerCase();
    if (!icon) {
        return `noun-icon.${fileType}`;
    }
    const nameSuffix = `-${icon.slugWithId || icon.id}`;
    const colorSuffix =
        color && color !== DEFAULT_COLOR
            ? `-${color.replace(/[^0-9A-Z]/gi, "")}`
            : "";
    return `noun${nameSuffix}${colorSuffix}.${fileType}`;
};

export const browserCanCopy =
    typeof window !== "undefined" &&
    typeof window.ClipboardItem === "function" &&
    window.navigator &&
    window.navigator.clipboard &&
    window.navigator.clipboard.write;

// Given editor state, return props formatted for Apollo / backend API
const formatEditorValuesForApollo = ({ iconId, state = {} }) => {
    const { flipX, flipY, rotation } = state[iconId] || {};

    const { iconColors, backgroundColors, shape } = state;

    const backgroundShape = shape === "ROUNDED" ? "ROUNDED_SQUARE" : shape;

    const foregroundColor =
        iconColors && iconColors.activeColor
            ? iconColors.activeColor
            : undefined;
    const backgroundShapeColor =
        backgroundColors &&
        backgroundColors.activeColor &&
        backgroundColors.activeColor !== ""
            ? backgroundColors.activeColor
            : undefined;
    const backgroundShapeOpacity = backgroundShapeColor ? 1 : 0;

    return {
        foregroundColor,
        backgroundShape,
        backgroundShapeColor,
        backgroundShapeOpacity,
        rotation,
        flipX,
        flipY
    };
};

// Return all props formatted for Apollo / backend API
export const formatValuesForApollo = ({
    iconId,
    downloadType: imageFormat = DEFAULT_DOWNLOAD_TYPE,
    downloadSize: exportSize = DEFAULT_DOWNLOAD_SIZE,
    ...editorValues
}) => {
    const {
        foregroundColor = DEFAULT_COLOR,
        backgroundShape = DEFAULT_BACKGROUND_SHAPE,
        backgroundShapeColor = DEFAULT_COLOR,
        backgroundShapeOpacity = 0.0,
        rotation = 0,
        flipX = false,
        flipY = false
    } = formatEditorValuesForApollo({
        iconId,
        state: editorValues
    });

    return {
        iconId,
        imageFormat,
        exportSize,
        foregroundColor,
        backgroundShapeColor,
        backgroundShapeOpacity,
        backgroundShape,
        rotation,
        flipX,
        flipY
    };
};

// Evaluate if backend has returned a rate limit error
export const hasRateLimitError = errors => {
    return (
        Array.isArray(errors) &&
        errors.some(error => {
            return error && error.message === "rate_limited";
        })
    );
};

// Send download / copy tracking to GA
export const trackDownload = ({ downloadType, iconId, type = "download" }) => {
    downloadType = downloadType.toLowerCase();
    const pageViewPath = `/download/icon/${downloadType}/${iconId}/`;
    sendPageView(pageViewPath);
    sendEvent(type, "icon", downloadType);
};
